<div class="flex-direction-column gap-10 align-center width-100">
  <app-form-field
    class="width-100"
    classe="login"
    heightFormField="50px"
    type="password"
    placeholder="Senha"
    iconColor="var(--primary)"
    iconPrefix="vpn_key"
    [isSenha]="true"
    backgroundColor="rgba(221, 188, 255, 0.1)"
    colorLabel="var(--primary)"
    [value]="loginSenhas.senha"
    (changeValue)="loginSenhas.senha = $event">
  </app-form-field>

  <app-form-field
    class="width-100"
    classe="login"
    heightFormField="50px"
    type="password"
    placeholder="Digite novamente sua senha"
    iconColor="var(--primary)"
    iconPrefix="vpn_key"
    [isSenha]="true"
    backgroundColor="rgba(221, 188, 255, 0.1)"
    colorLabel="var(--primary)"
    [value]="loginSenhas.confirmacaoSenha"
    (changeValue)="loginSenhas.confirmacaoSenha = $event">
  </app-form-field>

  <button mat-raised-button class="width-100" style="height: 50px; border: 1px solid var(--primary); color: var(--primary);" (click)="redefinirSenha()">
    Redefinir Senha
  </button>
</div>
